<template>
    <div class="row">
        <div v-if="loading" class="col-12">
            <div class="container mt-4">
                <div  class="text-center">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Cargando...</span>
                    </div>
                </div>
            </div>
        </div>
    
        <div v-else class="col-12" >
            <div class="col-4">
                <h2>Invoice Control</h2>
              
              </div>
            <!-- Tabs -->
            <Tabs 
                :tabSelected="tabSelected" 
                :tabs="tabs" 
                @change="changeTab($event)" 
                class="mx-3"
            />
          
            <div v-if="tabSelected === 1" class="mt-2">
                <!-- <h5 class="ml-1 my-2">Domains</h5> -->
                    
            <table class="table table-sm table-hover">
                <thead class="">
                    <tr>
                        <th class="p-1 m-0"></th>
                        <th 
                            class="p-2 small font-weight-bold text-right"
                            v-for="entry in domains" :key="entry.domain_date"
                        >
                            {{entry.month}}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr 
                        v-for="row in rows" 
                        :key="row.key" 
                        class="text-right"
                        :class="row.isBold ? 'font-weight-bold' : ''">
                        <th class="text-center">{{ row.label }}</th>
                        <td v-for="entry in domains" :key="entry.domain_date + row.key">
                            <span v-if="row.key =='invoice'" class="mr-1">
                                €                                
                            </span> 
                            {{ entry[row.key] }}
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>

            <div v-if="tabSelected === 2" class="mt-2">
                <h5 class="ml-1 my-2">Google Licenses</h5>

                <table class="table table-sm table-hover">
                <thead class="">
                    <tr>
                        <th class="p-1 m-0"></th>
                        <th 
                            class="p-2 small font-weight-bold text-right"
                            v-for="entry in googleLicenses" :key="entry.month"
                        >
                            {{entry.month}}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr 
                        v-for="row in rowsGoogleLicenses" 
                        :key="row.key" 
                        class="text-right"
                        :class="row.isBold ? 'font-weight-bold' : ''">
                        <th class="text-center">{{ row.label }}</th>
                        <td v-for="entry in googleLicenses" :key="entry.month + row.key">
                            <span v-if="row.key =='invoice'" class="mr-1">
                                €                                
                            </span>
                            {{ entry[row.key] }} 
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>

            <div v-if="tabSelected === 2" class="mt-2">
                <h5 class="ml-1 my-2">Apog Licenses</h5>
              
                <table class="table table-sm table-hover">
                <thead class="">
                    <tr>
                        <th class="p-1 m-0"></th>
                        <th 
                            class="p-2 small font-weight-bold text-right"
                            v-for="entry in microsoftLicenses" :key="entry.month"
                        >
                            {{entry.month}}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr 
                        v-for="row in rowsMicrosoftLicenses" 
                        :key="row.key" 
                        class="text-right"
                        :class="row.isBold ? 'font-weight-bold' : ''">
                        <th class="text-center">{{ row.label }}</th>
                        <td v-for="entry in microsoftLicenses" :key="entry.month + row.key">
                            <span v-if="row.key =='invoice'" class="mr-1">
                                €                                
                            </span>
                            {{ entry[row.key] }}
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>

            <div v-if="tabSelected === 2" class="mt-2">
                <h5 class="ml-1 my-2">Zapmail</h5>
              
                <table class="table table-sm table-hover">
                <thead class="">
                    <tr>
                        <th class="p-1 m-0"></th>
                        <th 
                            class="p-2 small font-weight-bold text-right"
                            v-for="entry in zapmailLicenses" :key="entry.month"
                        >
                            {{entry.month}}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr 
                        v-for="row in rowsZapmailLicenses" 
                        :key="row.key" 
                        class="text-right"
                        :class="row.isBold ? 'font-weight-bold' : ''">
                        <th class="text-center">{{ row.label }}</th>
                        <td v-for="entry in zapmailLicenses" :key="entry.month + row.key">
                            <span v-if="row.key =='invoice'" class="mr-1">
                                €                                
                            </span>
                            {{ entry[row.key] }}
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>

            <div v-if="tabSelected === 4" class="mt-2">
                <!-- <h5 class="ml-1 my-2">Phone lines</h5> -->
              
                <table class="table table-sm table-hover">
                <thead class="">
                    <tr>
                        <th class="p-1 m-0"></th>
                        <th 
                            class="p-2 small font-weight-bold text-right"
                            v-for="entry in phonesLines" :key="entry.month"
                        >
                            {{entry.month}}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr 
                        v-for="row in rowsPhoneLines" 
                        :key="row.key" 
                        class="text-right"
                        :class="row.isBold ? 'font-weight-bold' : ''">
                        <th class="text-center">{{ row.label }}</th>
                        <td v-for="entry in phonesLines" :key="entry.month + row.key">
                            <span v-if="row.key =='invoice'" class="mr-1">
                                €                                
                            </span>
                            {{ entry[row.key] }}
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>

            <div v-if="tabSelected === 5" class="mt-2">
                <!-- <h5 class="ml-1 my-2">Email enrichment</h5> -->
              
                <table class="table table-sm table-hover">
                  <thead class="">
                      <tr>
                          <th class="p-1 m-0"></th>
                          <th 
                              class="p-2 small font-weight-bold text-right"
                              v-for="entry in emails" :key="entry.month"
                          >
                              {{entry.month}}
                          </th>
                      </tr>
                  </thead>
  
                  <tbody>
                      <tr 
                          v-for="row in rowsEmails" 
                          :key="row.key" 
                          class="text-right"
                          :class="row.isBold ? 'font-weight-bold' : ''">
                          <th class="text-center">{{ row.label }}</th>
                          <td v-for="entry in emails" :key="entry.month + row.key">
                            <span v-if="row.key =='invoice'" class="mr-1">
                                €                                
                            </span>  
                            {{ entry[row.key] }}
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>

            <div v-if="tabSelected === 6" class="mt-2">
                <!-- <h5 class="ml-1 my-2">Mobile enrichment</h5> -->
              
                <table class="table table-sm table-hover">
                  <thead class="">
                      <tr>
                          <th class="p-1 m-0"></th>
                          <th 
                              class="p-2 small font-weight-bold text-right"
                              v-for="entry in mobiles" :key="entry.month"
                          >
                              {{entry.month}}
                          </th>
                      </tr>
                  </thead>
  
                  <tbody>
                      <tr 
                          v-for="row in rowsMobiles" 
                          :key="row.key" 
                          class="text-right"
                          :class="row.isBold ? 'font-weight-bold' : ''">
                          <th class="text-center">{{ row.label }}</th>
                          <td v-for="entry in mobiles" :key="entry.month + row.key">
                            <span v-if="row.key =='invoice'" class="mr-1">
                                €                                
                            </span>  
                            {{ entry[row.key] }}
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
        </div>
    </div>
  </template>
  
  <script>

import {  
  monitorService,  
} from "@/_services";
import Tabs from "@/components/Common/Tabs.vue";

  export default {
    name: 'InvoiceControl',
    components: {
      Tabs,
    },
    data() {
      return {
        tabSelected: 1,
        tabs: {
          1: {
            id: 1,
            name: 'Domains',
          },
          2: {
            id: 2,
            name: 'Email Licenses',
          },
        //   3: {
        //     id: 3,
        //     name: 'Microsoft Licenses',
        //   },
          4: {
            id: 4,
            name: 'Phone lines',
          },
          5: {
            id: 5,
            name: 'Email enrichment',
          },
          6: {
            id: 6,
            name: 'Mobile enrichment',
          },
        },
        domains: [],
        phonesLines: [],
        googleLicenses: [],
        microsoftLicenses: [],
        zapmailLicenses: [],
        emails: [],
        mobiles: [],
        loading: true,
        rows: [
          { key: 'new', label: 'New', isBold: false },
          { key: 'renew', label: 'Renewal', isBold: false },
          { key: 'total', label: 'Total', isBold: true },
          { key: 'invoice', label: 'Invoice', isBold: true }
        ],
        rowsPhoneLines: [
          { key: 'max_users_day', label: 'Max users day', isBold: false },          
          { key: 'invoice', label: 'Invoice', isBold: true }
        ],
        rowsEmails: [
          { key: 'prospects', label: 'New emails', isBold: false },          
          { key: 'invoice', label: 'Invoice', isBold: true }
        ],
        rowsMobiles: [
          { key: 'total', label: 'New mobiles', isBold: false },          
          { key: 'invoice', label: 'Invoice', isBold: true }
        ],
        rowsGoogleLicenses: [
          { key: 'previous_total', label: 'Total M-1', isBold: false },
          { key: 'new', label: 'New', isBold: false },
          { key: 'deleted', label: 'Deleted', isBold: false },
          { key: 'total', label: 'Total', isBold: false },          
          { key: 'invoice', label: 'Invoice', isBold: true }
        ],
        rowsMicrosoftLicenses: [
          { key: 'previous_total', label: 'Total M-1', isBold: false },
          { key: 'new', label: 'New', isBold: false },
          { key: 'deleted', label: 'Deleted', isBold: false },
          { key: 'total', label: 'Total', isBold: false },          
          { key: 'invoice', label: 'Invoice', isBold: true }
        ],
        rowsZapmailLicenses: [
          { key: 'previous_total', label: 'Total M-1', isBold: false },
          { key: 'new', label: 'New', isBold: false },
          { key: 'deleted', label: 'Deleted', isBold: false },
          { key: 'total', label: 'Total', isBold: false },          
          { key: 'invoice', label: 'Invoice', isBold: true }
        ],
      };
    },
    methods: {
        changeTab(value) {
            if (value == this.tabSelected) return;
            this.tabSelected = value;
        },
        getDataDomains() {
            monitorService.getInvoiceControl()
            .then((res) => {
                if (!res.error) {
                    this.domains = res.result.domains;
                    // this.googleLicenses = res.result.googleLicenses;
                    // this.microsoftLicenses = res.result.microsoftLicenses;
                    this.phonesLines = res.result.phonesLines;
                    this.emails = res.result.emails;
                    this.mobiles = res.result.mobiles;
                    //this.loading = false;
                }

                    monitorService.getInvoiceControlByWorkspace()
                    .then((res) => {
                        if (!res.error) {
                            
                            this.googleLicenses = res.result.googleLicenses;
                            this.microsoftLicenses = res.result.microsoftLicenses;
                            this.zapmailLicenses = res.result.zapmail;
                            
                            this.loading = false;
                        }
                    })
                    .catch(err => console.error('Error al cargar:', err))


            })
            .catch(err => console.error('Error al cargar:', err))
      },      
    },
    mounted() {
      this.getDataDomains();
    }
  };
  </script>
    